import { render, staticRenderFns } from "./SupportDetailsModal.vue?vue&type=template&id=466f1bf2&scoped=true"
import script from "./SupportDetailsModal.vue?vue&type=script&lang=js"
export * from "./SupportDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./SupportDetailsModal.vue?vue&type=style&index=0&id=466f1bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466f1bf2",
  null
  
)

export default component.exports